export default __webpack_public_path__ + "static/media/Awake.e863ff67.png";